<template>
  <b-form class="login-form" @submit.prevent="onSubmit">
    <b-alert
        :variant="formAlertType"
        show
        v-if="!formState.processing && (formState.message.length > 0 || formState.success)"
    >
      <template v-if="formState.success">
        <p>We have sent an email with instructions to reset your password.</p>
        <p>If you don't get it, please verify you entered a correct email address or check your spam folder</p>
      </template>
      <template v-else>
        {{ formState.message }}
      </template>
    </b-alert>

    <b-form-group label="Email address">
      <b-form-input
          v-model.trim="formData.email"
          type="text"
          :state="emailInvalid"
      />
      <b-form-invalid-feedback :state="emailInvalid">
        {{ formValidation.email }}
      </b-form-invalid-feedback>
    </b-form-group>

    <b-button type="submit" variant="primary" block class="login-submit" :disabled="formState.processing">
      {{ !formState.processing ? 'Submit' : 'Processing...' }}
    </b-button>
  </b-form>
</template>

<script>
import {API_ROUTES} from "../api";

export default {
  computed: {
    formAlertType: function () {
      return this.formState.success ? 'success' : 'danger';
    },
    emailInvalid: function () {
      return this.formValidation.email.length > 0 ? false : null;
    }
  },
  data() {
    return {
      formData: {
        email: '',
        to_base_app: true
      },
      formValidation: {
        email: ''
      },
      formState: {
        success: null,
        message: '',
        processing: false
      }
    }
  },
  methods: {
    onSubmit() {
      this.formState.processing = true;
      for (let fieldName in this.formValidation) {
        this.formValidation[fieldName] = '';
      }
      this.$api.post(API_ROUTES.FORGOT_PASSWORD, this.formData).then(({data}) => {
        this.formState.success = true;
        this.formState.message = '';
      }).catch(({response: {data}}) => {
        this.formState.success = false;
        if (typeof data.errors !== 'undefined') {
          for (let fieldName in this.formValidation) {
            if (typeof data.errors[fieldName] !== 'undefined') {
              this.formValidation[fieldName] = data.errors[fieldName].join(', ');
            }
          }
        }
        if (typeof data.message !== 'undefined') {
          this.formState.message = data.message;
        }
      }).finally(() => {
        this.formState.processing = false;
      });
    }
  }
}
</script>
